import {makeStyles} from "@material-ui/core/styles";
import {colors} from '../../../shared/colors';

const useStyles = makeStyles(() => ({
    advSearchLink: {
        padding: '0.5rem',
        '&:hover': {
            cursor: 'pointer',
            color: colors.magellanPurple,
            fontWeight: 'underline'
        }
    },
    searchOption: {
        padding: '0.5rem',
    }
}));

export const _optionsStyle = {
    color: colors.magellanPurple
}

export default useStyles;
